module.exports = __webpack_public_path__ + "static/media/facebookBlack.d85c5661.svg";